export const STAGE = __STAGE__;
